import React from 'react';
import {
	Card, Row, Col, Button, Tag, Spin, Tooltip, Empty, Alert, Collapse,
	Typography, Table, Tabs, Modal, Input, Select, message,
} from 'antd';
import {
	WarningOutlined, SafetyCertificateOutlined, RedoOutlined, IdcardOutlined,
	CheckCircleOutlined, CloseCircleOutlined, ClockCircleOutlined,
	EyeOutlined, EditOutlined, SaveOutlined,
} from '@ant-design/icons';
import { connect } from 'react-redux';
import { initHandler, ajaxViewHandler, extractResult } from '../../store/actions';
import { Helmet } from 'react-helmet';
import Config from '../../Config';

const { Text } = Typography;
const { Panel } = Collapse;
const { TabPane } = Tabs;
const { TextArea } = Input;

// Laporan audit - lihat diskusi 2026-10-13. NIK yang dipakai di >1 baris
// Kendaraan aktif dengan kombinasi nama/alamat BERBEDA - indikasi human-
// error/fraud di instansi penerbit STNK/BPKB (longgarnya validasi NIK di
// luar sistem kita), bukan bug internal. Tab "Varian Terdeteksi" read-only.
// Tab "Pengajuan Pending" (khusus Pendaftaran Lama yang diblokir) punya aksi
// Setujui/Tolak, digerbang hak_akses terpisah approval_koreksi_data_pemilik.
const configClass = {
	title: 'Laporan Audit NIK',
	apiUrl: {
		data: 'laporan/api/audit-nik/',
		detail: (id) => `laporan/api/audit-nik/${id}/detail/`,
		edit: (id) => `laporan/api/audit-nik/${id}/edit/`,
		pending: 'laporan/api/approval-koreksi-data-pemilik/',
		setujui: (id) => `laporan/api/approval-koreksi-data-pemilik/${id}/setujui/`,
		tolak: (id) => `laporan/api/approval-koreksi-data-pemilik/${id}/tolak/`,
		kabupaten: 'master/api/kabupaten/',
		upt: 'pegawai/api/upt/',
	},
};

const config = new Config();

class LapAuditNik extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isMobile: window.innerWidth <= 768,
			activeTab: 'varian',

			loading: false,
			list: [],
			ringkasan: { total_nik_bermasalah: 0, total_baris_kendaraan: 0, total_kombinasi_beda: 0 },

			loadingPending: false,
			pendingList: [],
			kabupatenList: [],
			uptList: [],
			selectedKabupaten: null,
			selectedUpt: null,

			modalTolak: null, // { id, nik }
			catatanTolak: '',
			loadingAksi: false,

			modalDetail: null, // hasil GET detail (object) saat modal detail dibuka
			loadingDetail: false,
			editMode: false,
			editForm: { nama: '', alamat: '', no_hp: '', email: '' },
			savingEdit: false,
		};
	}

	UNSAFE_componentWillMount() {
		this.props.initHandler();
	}

	componentDidMount() {
		this._handleResize = () => this.setState({ isMobile: window.innerWidth <= 768 });
		window.addEventListener('resize', this._handleResize);
		this.fetchData();
		if (this._punyaAksesApproval()) {
			this.fetchPending();
			if (this.props.is_superuser || this.props.level_user === 1 || this.props.level_user === 2) {
				this.fetchKabupaten();
			}
		}
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this._handleResize);
	}

	_punyaAksesApproval = () => {
		return Boolean(this.props.akses && this.props.akses.approval_koreksi_data_pemilik === true);
	};

	_isAdminAtas = () => {
		return Boolean(this.props.is_superuser || this.props.level_user === 1 || this.props.level_user === 2);
	};

	_punyaAksesEdit = () => {
		return Boolean(this.props.akses && this.props.akses.laporan_audit_nik_edit === true);
	};

	fetchData = () => {
		this.setState({ loading: true });
		this.props.ajaxViewHandler('get', configClass.apiUrl.data)
			.then((action) => {
				const { isSuccess, responseMsg } = extractResult(action);
				if (isSuccess && responseMsg) {
					this.setState({
						list: Array.isArray(responseMsg.results) ? responseMsg.results : [],
						ringkasan: responseMsg.ringkasan || this.state.ringkasan,
					});
				}
				this.setState({ loading: false });
			}).catch(() => this.setState({ loading: false }));
	};

	fetchPending = () => {
		const { selectedKabupaten, selectedUpt } = this.state;
		let url = configClass.apiUrl.pending;
		const params = [];
		if (selectedUpt) params.push(`upt=${selectedUpt}`);
		else if (selectedKabupaten) params.push(`kabupaten=${selectedKabupaten}`);
		if (params.length) url += `?${params.join('&')}`;

		this.setState({ loadingPending: true });
		this.props.ajaxViewHandler('get', url)
			.then((action) => {
				const { isSuccess, responseMsg } = extractResult(action);
				if (isSuccess && responseMsg) {
					this.setState({ pendingList: Array.isArray(responseMsg.results) ? responseMsg.results : [] });
				}
				this.setState({ loadingPending: false });
			}).catch(() => this.setState({ loadingPending: false }));
	};

	fetchKabupaten = () => {
		this.props.ajaxViewHandler('get', `${configClass.apiUrl.kabupaten}?limit=200`)
			.then((action) => {
				const { isSuccess, responseMsg } = extractResult(action);
				if (isSuccess) this.setState({ kabupatenList: (responseMsg && responseMsg.results) || [] });
			});
	};

	handleKabupatenChange = (val) => {
		this.setState({ selectedKabupaten: val, selectedUpt: null, uptList: [] }, () => {
			this.fetchPending();
			if (val) {
				this.props.ajaxViewHandler('get', `${configClass.apiUrl.upt}?kabupaten=${val}&limit=200`)
					.then((action) => {
						const { isSuccess, responseMsg } = extractResult(action);
						if (isSuccess) this.setState({ uptList: (responseMsg && responseMsg.results) || [] });
					});
			}
		});
	};

	handleUptChange = (val) => {
		this.setState({ selectedUpt: val }, this.fetchPending);
	};

	openModalTolak = (row) => {
		this.setState({ modalTolak: row, catatanTolak: '' });
	};

	closeModalTolak = () => {
		if (this.state.loadingAksi) return;
		this.setState({ modalTolak: null, catatanTolak: '' });
	};

	handleSetujui = (row) => {
		this.setState({ loadingAksi: true });
		this.props.ajaxViewHandler('post', configClass.apiUrl.setujui(row.id), {})
			.then((action) => {
				const { isSuccess, responseMsg } = extractResult(action);
				this.setState({ loadingAksi: false });
				if (isSuccess) {
					message.success({ content: (responseMsg && responseMsg.message) || 'Disetujui', duration: 4, key: 'toast' });
					this.fetchPending();
					this.fetchData();
				} else {
					message.error({ content: (responseMsg && responseMsg.error) || 'Gagal memproses', duration: 3, key: 'toast' });
				}
			}).catch(() => {
				this.setState({ loadingAksi: false });
				message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' });
			});
	};

	submitTolak = () => {
		const { modalTolak, catatanTolak } = this.state;
		if (!modalTolak) return;
		this.setState({ loadingAksi: true });
		this.props.ajaxViewHandler('post', configClass.apiUrl.tolak(modalTolak.id), { catatan: catatanTolak.trim() })
			.then((action) => {
				const { isSuccess, responseMsg } = extractResult(action);
				this.setState({ loadingAksi: false });
				if (isSuccess) {
					message.success({ content: (responseMsg && responseMsg.message) || 'Ditolak', duration: 3, key: 'toast' });
					this.setState({ modalTolak: null, catatanTolak: '' });
					this.fetchPending();
				} else {
					message.error({ content: (responseMsg && responseMsg.error) || 'Gagal memproses', duration: 3, key: 'toast' });
				}
			}).catch(() => {
				this.setState({ loadingAksi: false });
				message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' });
			});
	};

	openDetail = (row) => {
		this.setState({ loadingDetail: true, modalDetail: { id: row.id }, editMode: false });
		this.props.ajaxViewHandler('get', configClass.apiUrl.detail(row.id))
			.then((action) => {
				const { isSuccess, responseMsg } = extractResult(action);
				if (isSuccess && responseMsg) {
					this.setState({
						modalDetail: responseMsg,
						editForm: {
							nama: responseMsg.nama || '',
							alamat: responseMsg.alamat || '',
							no_hp: responseMsg.no_hp || '',
							email: responseMsg.email || '',
						},
					});
				} else {
					message.error({ content: 'Gagal mengambil detail data', duration: 3, key: 'toast' });
					this.setState({ modalDetail: null });
				}
				this.setState({ loadingDetail: false });
			}).catch(() => {
				this.setState({ loadingDetail: false, modalDetail: null });
				message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' });
			});
	};

	closeDetail = () => {
		if (this.state.savingEdit) return;
		this.setState({ modalDetail: null, editMode: false });
	};

	enterEditMode = () => {
		const { modalDetail } = this.state;
		this.setState({
			editMode: true,
			editForm: {
				nama: modalDetail.nama || '',
				alamat: modalDetail.alamat || '',
				no_hp: modalDetail.no_hp || '',
				email: modalDetail.email || '',
			},
		});
	};

	cancelEditMode = () => {
		this.setState({ editMode: false });
	};

	handleEditFieldChange = (field, value) => {
		this.setState((prev) => ({ editForm: { ...prev.editForm, [field]: value } }));
	};

	submitEdit = () => {
		const { modalDetail, editForm } = this.state;
		if (!modalDetail || !modalDetail.id) return;
		if (!editForm.nama.trim()) {
			message.error({ content: 'Nama tidak boleh kosong', duration: 3, key: 'toast' });
			return;
		}
		this.setState({ savingEdit: true });
		this.props.ajaxViewHandler('patch', configClass.apiUrl.edit(modalDetail.id), {
			nama: editForm.nama.trim(),
			alamat: editForm.alamat.trim(),
			no_hp: editForm.no_hp.trim(),
			email: editForm.email.trim(),
		}).then((action) => {
			const { isSuccess, responseMsg } = extractResult(action);
			this.setState({ savingEdit: false });
			if (isSuccess) {
				message.success({ content: (responseMsg && responseMsg.message) || 'Koreksi tersimpan', duration: 3, key: 'toast' });
				this.setState((prev) => ({
					editMode: false,
					modalDetail: { ...prev.modalDetail, ...editForm },
				}));
				this.fetchData(); // sinkron tabel utama (nama/alamat yang ditampilkan ikut berubah)
			} else {
				message.error({ content: (responseMsg && responseMsg.error) || 'Gagal menyimpan koreksi', duration: 3, key: 'toast' });
			}
		}).catch(() => {
			this.setState({ savingEdit: false });
			message.error({ content: 'Gagal request data, coba lagi', duration: 2, key: 'toast' });
		});
	};

	_renderRingkasanCards() {
		const { ringkasan } = this.state;
		const cards = [
			{ label: 'NIK Terdeteksi Ganda', value: ringkasan.total_nik_bermasalah, color: '#cf1322', icon: <WarningOutlined /> },
			{ label: 'Total Baris Kendaraan Terlibat', value: ringkasan.total_baris_kendaraan, color: '#0f2847', icon: <SafetyCertificateOutlined /> },
			{ label: 'Kombinasi Nama/Alamat Berbeda', value: ringkasan.total_kombinasi_beda, color: '#d4b106', icon: <IdcardOutlined /> },
		];
		return (
			<Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
				{cards.map((c) => (
					<Col key={c.label} xs={24} sm={8}>
						<Card style={{ borderRadius: 14, border: 'none', boxShadow: '0 4px 20px rgba(15,40,71,0.08)' }} bodyStyle={{ padding: 20 }}>
							<div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
								<div style={{
									width: 48, height: 48, borderRadius: 12, flexShrink: 0,
									background: `${c.color}14`, color: c.color,
									display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 22,
								}}>
									{c.icon}
								</div>
								<div>
									<div style={{ fontSize: 26, fontWeight: 800, color: c.color, lineHeight: 1 }}>{c.value}</div>
									<div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>{c.label}</div>
								</div>
							</div>
						</Card>
					</Col>
				))}
			</Row>
		);
	}

	_renderGroupHeader(g) {
		return (
			<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8, width: '100%' }}>
				<div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
					<span style={{ fontFamily: 'monospace', fontWeight: 800, fontSize: 15, color: '#0f2847' }}>{g.nik}</span>
					<Tag style={{ borderRadius: 20, fontWeight: 600, margin: 0 }}>{g.jumlah_kendaraan} catatan</Tag>
					<Tag
						icon={<WarningOutlined />}
						style={{ borderRadius: 20, fontWeight: 600, margin: 0, background: '#fff1f0', borderColor: '#ffa39e', color: '#cf1322' }}
					>
						{g.jumlah_kombinasi} kombinasi nama/alamat berbeda
					</Tag>
				</div>
			</div>
		);
	}

	_renderGroupTable(g) {
		const statusColor = { otomatis: 'blue', disetujui: 'green' };
		const columns = [
			{ title: 'Nopol', dataIndex: 'nomor_polisi', key: 'nomor_polisi', render: (v) => <Text style={{ fontFamily: 'monospace', fontWeight: 700 }}>{v || '-'}</Text> },
			{ title: 'NIK', dataIndex: 'nik', key: 'nik', render: (v) => <Text style={{ fontFamily: 'monospace' }}>{v || '-'}</Text> },
			{ title: 'Nama', dataIndex: 'nama', key: 'nama' },
			{ title: 'Alamat', dataIndex: 'alamat', key: 'alamat' },
			{ title: 'Sumber', dataIndex: 'sumber', key: 'sumber', width: 160 },
			{ title: 'Status', dataIndex: 'status', key: 'status', width: 110,
				render: (v) => <Tag color={statusColor[v] || 'default'}>{v}</Tag> },
			{ title: 'UPT', dataIndex: 'upt', key: 'upt' },
			{ title: 'Aksi', key: 'aksi', width: 90, align: 'center', render: (_, r) => (
				<Button size="small" icon={<EyeOutlined />} onClick={() => this.openDetail(r)}>Detail</Button>
			) },
		];
		return (
			<Table
				size="small"
				pagination={false}
				rowKey="id"
				dataSource={g.baris}
				columns={columns}
				scroll={{ x: true }}
			/>
		);
	}

	_renderTabVarian() {
		const { loading, list } = this.state;
		if (loading && list.length === 0) {
			return <div style={{ textAlign: 'center', padding: 48 }}><Spin size="large" /></div>;
		}
		if (list.length === 0) {
			return <Empty description="Tidak ada NIK dengan kombinasi nama/alamat berbeda terdeteksi" />;
		}
		return (
			<Collapse bordered={false}>
				{list.map((g) => (
					<Panel
						key={g.nik}
						style={{ marginBottom: 8, borderRadius: 10, overflow: 'hidden', border: '1px solid #ffccc7' }}
						header={this._renderGroupHeader(g)}
					>
						{this._renderGroupTable(g)}
					</Panel>
				))}
			</Collapse>
		);
	}

	_renderFilterUpt() {
		if (!this._isAdminAtas()) return null;
		const { kabupatenList, uptList, selectedKabupaten, selectedUpt } = this.state;
		return (
			<div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', marginBottom: 16 }}>
				<Select
					allowClear showSearch optionFilterProp="children" placeholder="Filter Kabupaten/Kota (opsional)..."
					style={{ minWidth: 220, borderRadius: 8 }}
					value={selectedKabupaten || undefined}
					onChange={this.handleKabupatenChange}
				>
					{kabupatenList.map(k => <Select.Option key={k.id} value={k.id}>{k.name}</Select.Option>)}
				</Select>
				<Select
					allowClear showSearch optionFilterProp="children" placeholder="Filter UPT (pilih Kabupaten dulu)..."
					style={{ minWidth: 220, borderRadius: 8 }}
					value={selectedUpt || undefined}
					disabled={!selectedKabupaten}
					onChange={this.handleUptChange}
				>
					{uptList.map(u => <Select.Option key={u.id} value={u.id}>{u.nama}</Select.Option>)}
				</Select>
			</div>
		);
	}

	_renderTabPending() {
		const { loadingPending, pendingList, loadingAksi } = this.state;
		return (
			<>
				<Alert
					type="warning" showIcon style={{ marginBottom: 16 }}
					message="Khusus Pendaftaran Lama yang diblokir"
					description="Pengajuan ini muncul saat staf submit Pendaftaran Lama dengan NIK yang sudah ada tapi nama/alamat berbeda, dan staf tersebut TIDAK punya akses approval. Transaksi kendaraannya BELUM dibuat sama sekali - begitu disetujui, data pemilik diperbarui dan staf perlu MENGULANGI pendaftarannya."
				/>
				{this._renderFilterUpt()}
				{loadingPending && pendingList.length === 0 ? (
					<div style={{ textAlign: 'center', padding: 48 }}><Spin size="large" /></div>
				) : pendingList.length === 0 ? (
					<Empty description="Tidak ada pengajuan pending" />
				) : (
					<Table
						size="small"
						rowKey="id"
						pagination={{ pageSize: 10 }}
						dataSource={pendingList}
						scroll={{ x: true }}
						columns={[
							{ title: 'NIK', dataIndex: 'nik', key: 'nik', render: (v) => <Text style={{ fontFamily: 'monospace', fontWeight: 700 }}>{v}</Text> },
							{ title: 'Tercatat (Lama)', key: 'lama', render: (_, r) => (
								<div><div>{r.nama_tercatat}</div><div style={{ fontSize: 11, color: '#888' }}>{r.alamat_tercatat}</div></div>
							) },
							{ title: 'Diajukan (Baru)', key: 'baru', render: (_, r) => (
								<div>
									<div>{r.nama_diajukan} {r.beda_nama && <Tag color="red" style={{ marginLeft: 4 }}>beda nama</Tag>}</div>
									<div style={{ fontSize: 11, color: '#888' }}>{r.alamat_diajukan} {r.beda_alamat && <Tag color="orange">beda alamat</Tag>}</div>
								</div>
							) },
							{ title: 'UPT', dataIndex: 'upt', key: 'upt' },
							{ title: 'Diajukan Oleh', dataIndex: 'diajukan_oleh', key: 'diajukan_oleh' },
							{ title: 'Tanggal', dataIndex: 'created_at', key: 'created_at', width: 150,
								render: (v) => v ? new Date(v).toLocaleString('id-ID') : '-' },
							{ title: 'Aksi', key: 'aksi', width: 190, align: 'center', render: (_, r) => (
								<div style={{ display: 'flex', gap: 6, justifyContent: 'center' }}>
									<Button type="primary" size="small" icon={<CheckCircleOutlined />} loading={loadingAksi}
										onClick={() => this.handleSetujui(r)}>Setujui</Button>
									<Button danger size="small" icon={<CloseCircleOutlined />} onClick={() => this.openModalTolak(r)}>Tolak</Button>
								</div>
							) },
						]}
					/>
				)}
			</>
		);
	}

	_renderModalTolak() {
		const { modalTolak, catatanTolak, loadingAksi, isMobile } = this.state;
		if (!modalTolak) return null;
		return (
			<Modal
				title="Tolak Pengajuan Koreksi Data Pemilik"
				visible={true}
				onCancel={this.closeModalTolak}
				closable={!loadingAksi}
				maskClosable={false}
				width={isMobile ? '94%' : 480}
				footer={[
					<Button key="batal" onClick={this.closeModalTolak} disabled={loadingAksi}>Batal</Button>,
					<Button key="submit" danger type="primary" loading={loadingAksi} onClick={this.submitTolak}>Tolak</Button>,
				]}
			>
				<div style={{ marginBottom: 12, fontSize: 13, color: '#595959' }}>
					<div><b>NIK:</b> {modalTolak.nik}</div>
					<div><b>Diajukan:</b> {modalTolak.nama_diajukan}</div>
				</div>
				<div style={{ marginBottom: 6, fontWeight: 600, fontSize: 13 }}>Catatan (opsional)</div>
				<TextArea
					rows={3}
					value={catatanTolak}
					onChange={(e) => this.setState({ catatanTolak: e.target.value })}
					placeholder="Alasan penolakan..."
					disabled={loadingAksi}
				/>
			</Modal>
		);
	}

	_renderModalDetail() {
		const { modalDetail, loadingDetail, editMode, editForm, savingEdit, isMobile } = this.state;
		if (!modalDetail) return null;
		const statusColor = { otomatis: 'blue', disetujui: 'green', pending: 'orange', ditolak: 'red' };
		// Placeholder saat modal baru dibuka cuma berisi {id} - sumber_label
		// belum ada sampai respons GET detail datang.
		const isLoadingAwal = loadingDetail && modalDetail.sumber_label === undefined;

		return (
			<Modal
				title={<span><IdcardOutlined style={{ marginRight: 8 }} />Detail Pengajuan Identitas</span>}
				visible={true}
				onCancel={this.closeDetail}
				closable={!savingEdit}
				maskClosable={!savingEdit}
				width={isMobile ? '94%' : 620}
				footer={editMode ? [
					<Button key="batal" onClick={this.cancelEditMode} disabled={savingEdit}>Batal</Button>,
					<Button key="simpan" type="primary" icon={<SaveOutlined />} loading={savingEdit} onClick={this.submitEdit}>
						Simpan Koreksi
					</Button>,
				] : [
					<Button key="tutup" onClick={this.closeDetail}>Tutup</Button>,
					this._punyaAksesEdit() && modalDetail.status && !['pending', 'ditolak'].includes(modalDetail.status) ? (
						<Button key="edit" type="primary" icon={<EditOutlined />} onClick={this.enterEditMode}>
							Edit / Koreksi
						</Button>
					) : null,
				]}
			>
				{isLoadingAwal ? (
					<div style={{ textAlign: 'center', padding: 32 }}><Spin size="large" /></div>
				) : (
					<div>
						<div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginBottom: 16 }}>
							<div>
								<div style={{ fontSize: 11, color: '#888' }}>Nomor Polisi</div>
								<Text style={{ fontFamily: 'monospace', fontWeight: 700, fontSize: 15 }}>{modalDetail.nomor_polisi || '-'}</Text>
							</div>
							<div>
								<div style={{ fontSize: 11, color: '#888' }}>NIK</div>
								<Text style={{ fontFamily: 'monospace', fontWeight: 700, fontSize: 15 }}>{modalDetail.nik || '-'}</Text>
							</div>
							<div>
								<div style={{ fontSize: 11, color: '#888' }}>Status</div>
								<Tag color={statusColor[modalDetail.status] || 'default'}>{modalDetail.status_label || modalDetail.status}</Tag>
							</div>
							<div>
								<div style={{ fontSize: 11, color: '#888' }}>Sumber</div>
								<Tag>{modalDetail.sumber_label}</Tag>
							</div>
						</div>

						{(modalDetail.beda_nama || modalDetail.beda_alamat) && (
							<Alert
								type="warning" showIcon style={{ marginBottom: 16 }}
								message="Dibandingkan dengan data tercatat di WajibPajak"
								description={
									<div style={{ fontSize: 12 }}>
										<div>Tercatat: <b>{modalDetail.nama_tercatat || '-'}</b> / {modalDetail.alamat_tercatat || '-'}</div>
										<div>Diajukan baris ini: <b>{modalDetail.nama}</b> / {modalDetail.alamat}</div>
									</div>
								}
							/>
						)}

						<Row gutter={[12, 12]}>
							<Col span={24}>
								<div style={{ fontSize: 12, fontWeight: 600, marginBottom: 4 }}>Nama</div>
								{editMode ? (
									<Input value={editForm.nama} onChange={(e) => this.handleEditFieldChange('nama', e.target.value)} disabled={savingEdit} />
								) : <div>{modalDetail.nama || '-'}</div>}
							</Col>
							<Col span={24}>
								<div style={{ fontSize: 12, fontWeight: 600, marginBottom: 4 }}>Alamat</div>
								{editMode ? (
									<TextArea rows={2} value={editForm.alamat} onChange={(e) => this.handleEditFieldChange('alamat', e.target.value)} disabled={savingEdit} />
								) : <div>{modalDetail.alamat || '-'}</div>}
							</Col>
							<Col xs={24} sm={12}>
								<div style={{ fontSize: 12, fontWeight: 600, marginBottom: 4 }}>No. HP</div>
								{editMode ? (
									<Input value={editForm.no_hp} onChange={(e) => this.handleEditFieldChange('no_hp', e.target.value)} disabled={savingEdit} />
								) : <div>{modalDetail.no_hp || '-'}</div>}
							</Col>
							<Col xs={24} sm={12}>
								<div style={{ fontSize: 12, fontWeight: 600, marginBottom: 4 }}>Email</div>
								{editMode ? (
									<Input value={editForm.email} onChange={(e) => this.handleEditFieldChange('email', e.target.value)} disabled={savingEdit} />
								) : <div>{modalDetail.email || '-'}</div>}
							</Col>
							<Col span={24}>
								<div style={{ fontSize: 12, fontWeight: 600, marginBottom: 4 }}>Desa/Kecamatan/Kabupaten</div>
								<div>
									{modalDetail.desa ? `${modalDetail.desa.nama}, ${modalDetail.desa.kecamatan}, ${modalDetail.desa.kabupaten}` : '-'}
								</div>
							</Col>
						</Row>

						<div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', marginTop: 16, fontSize: 12, color: '#595959' }}>
							<div><b>UPT:</b> {modalDetail.upt || '-'}</div>
							<div><b>Diajukan oleh:</b> {modalDetail.diajukan_oleh || '-'}</div>
							<div><b>Disetujui oleh:</b> {modalDetail.disetujui_oleh || '-'}</div>
							<div><b>Dibuat:</b> {modalDetail.created_at ? new Date(modalDetail.created_at).toLocaleString('id-ID') : '-'}</div>
						</div>

						{modalDetail.catatan && (
							<div style={{ marginTop: 16 }}>
								<div style={{ fontSize: 12, fontWeight: 600, marginBottom: 4 }}>Catatan / Riwayat Koreksi</div>
								<pre style={{
									whiteSpace: 'pre-wrap', fontSize: 12, background: '#fafafa',
									border: '1px solid #f0f0f0', borderRadius: 6, padding: 10, margin: 0,
								}}>{modalDetail.catatan}</pre>
							</div>
						)}

						{editMode && (
							<Alert
								type="info" showIcon style={{ marginTop: 16 }}
								message="Koreksi ini mengubah LANGSUNG baris yang sama (bukan membuat baris baru) dan akan tercatat di Catatan di atas."
							/>
						)}
					</div>
				)}
			</Modal>
		);
	}

	render() {
		const { isMobile, loading, loadingPending, activeTab } = this.state;
		const punyaAksesApproval = this._punyaAksesApproval();
		return (
			<div>
				<Helmet>
					<title>{configClass.title + ' | ' + config.get_site_info().name}</title>
				</Helmet>

				<Card style={{ borderRadius: 14, boxShadow: '0 4px 20px rgba(0,0,0,0.07)', overflow: 'hidden', marginBottom: 16 }} bodyStyle={{ padding: 0 }}>
					<div style={{
						padding: '16px 20px',
						background: 'linear-gradient(135deg, #0f2847, #1e4d8a)',
						display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 10,
					}}>
						<div style={{ color: '#fff', fontWeight: 700, fontSize: 17 }}>
							<IdcardOutlined style={{ marginRight: 8 }} />
							{configClass.title}
						</div>
						<Tooltip title="Refresh data">
							<Button icon={<RedoOutlined />} style={{ borderRadius: 8, background: 'rgba(255,255,255,0.15)', border: 'none', color: '#fff' }}
								onClick={() => { this.fetchData(); if (punyaAksesApproval) this.fetchPending(); }}
								loading={loading || loadingPending}>
								{!isMobile && 'Refresh'}
							</Button>
						</Tooltip>
					</div>
					<div style={{ padding: 20 }}>
						{!punyaAksesApproval ? (
							<>
								<Alert
									type="info" showIcon style={{ marginBottom: 16 }}
									message="Kegunaan laporan ini"
									description="Menunjukkan NIK yang dipakai di lebih dari satu kendaraan dengan kombinasi nama/alamat BERBEDA - biasanya karena validasi NIK yang longgar di instansi penerbit STNK/BPKB (bukan bug internal sistem ini). Murni observasi."
								/>
								{this._renderRingkasanCards()}
								{this._renderTabVarian()}
							</>
						) : (
							<Tabs activeKey={activeTab} onChange={(k) => this.setState({ activeTab: k })}>
								<TabPane tab="Varian Terdeteksi" key="varian">
									{this._renderRingkasanCards()}
									{this._renderTabVarian()}
								</TabPane>
								<TabPane tab={<span><ClockCircleOutlined /> Pengajuan Pending</span>} key="pending">
									{this._renderTabPending()}
								</TabPane>
							</Tabs>
						)}
					</div>
				</Card>

				{this._renderModalTolak()}
				{this._renderModalDetail()}
			</div>
		);
	}
}

const mapStateToProps = function (state) {
	return state.configReducers;
};

export default connect(
	mapStateToProps,
	{ initHandler, ajaxViewHandler }
)(LapAuditNik);
